import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, delay, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SplitViewObserverService {
  private splitViewMovement$ = new BehaviorSubject<{ gutterNumber?: number; isMoving?: boolean }>({
    gutterNumber: 0,
  });
  notifyMoved(event: any) {
    this.splitViewMovement$.next({ gutterNumber: event.gutterNum || 0, isMoving: false });
  }

  notifyMoving(isMoving: boolean) {
    this.splitViewMovement$.next({ isMoving });
  }

  observe() {
    // delay 0, to relax the changedetection.
    return this.splitViewMovement$.pipe(shareReplay(1), delay(100));
  }
}
